<template>
  <v-card flat class="pa-4">
    <div v-if="!deleting">
      <v-card-title>
        {{ $t("Are you REALLY sure?") }}
      </v-card-title>
      <v-card-text>
        {{ $t("If you delete your account all your data will be erased") }}
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn
          outlined
          color="primary"
          @click="closeConfirmDeleteAccountDialog"
          class="mr-10"
        >
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn outlined color="red" @click="deleting = true">
          {{ $t("Delete account") }}
        </v-btn>
      </v-card-actions>
    </div>
    <div v-else>
      <v-card-title>
        {{ $t("Enter your password to delete your account") }}
      </v-card-title>
      <v-text-field
        :label="$t('Password')"
        outlined
        flat
        dense
        name="password"
        v-model="password"
        prepend-inner-icon="mdi-lock-outline"
        :rules="[validatePassword]"
        :error-messages="$t(passwordError)"
        type="password"
        @keydown.enter="submitPassword"
        class="mx-4"
      />
      <v-card-actions class="d-flex justify-end">
        <v-btn
          outlined
          color="primary"
          @click="closeConfirmDeleteAccountDialog"
          class="mr-10"
        >
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          outlined
          color="red"
          @click="submitPassword"
          :disabled="!password"
        >
          {{ $t("Delete account") }}
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import AuthService from "@/service/auth_service";

export default {
  data() {
    return { deleting: false, password: "", passwordError: "" };
  },

  async deleteAccount() {
    await AuthService.deleteAccount();
  },

  methods: {
    closeConfirmDeleteAccountDialog() {
      this.$emit("close");
    },

    validatePassword() {
      if (this.passwordError) {
        return this.passwordError;
      }
      return this.password ? true : "This field is required";
    },

    async submitPassword() {
      try {
        await AuthService.verifyPassword(this.password);
        await AuthService.deleteAccount();
      } catch (error) {
        this.passwordError = "Wrong password";
      }
    }
  }
};
</script>
